import { createElement as e, useId as t } from "react";
import { Fragment as n, jsx as r, jsxs as i } from "react/jsx-runtime";
import { renderToStaticMarkup as a } from "react-dom/server";
//#region src/lib/core/defaults.ts
function o() {
	return {
		measurements: {
			widthMm: 1e3,
			heightMm: 1e3
		},
		configuration: {
			schemaVersion: 1,
			view: "inside",
			panels: [{ openingType: "fixed" }],
			frameColor: "#ffffff"
		}
	};
}
//#endregion
//#region src/lib/core/validation.ts
var s = /* @__PURE__ */ new Set([
	"fixed",
	"turn",
	"tilt",
	"tilt_turn",
	"sliding"
]), c = /* @__PURE__ */ new Set(["left", "right"]);
function l(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
function u(e) {
	if (!l(e)) return [{
		path: "configuration",
		code: "INVALID_CONFIGURATION",
		message: "Configuration must be an object."
	}];
	let t = [];
	return e.schemaVersion !== 1 && t.push({
		path: "configuration.schemaVersion",
		code: "UNSUPPORTED_SCHEMA_VERSION",
		message: `Unsupported configuration schema version: ${String(e.schemaVersion)}.`
	}), e.view !== "inside" && t.push({
		path: "configuration.view",
		code: "INVALID_VIEW",
		message: "View must be \"inside\"."
	}), e.frameColor !== void 0 && typeof e.frameColor != "string" && t.push({
		path: "configuration.frameColor",
		code: "INVALID_FRAME_COLOR",
		message: "Frame colour must be a string when provided."
	}), !Array.isArray(e.panels) || e.panels.length < 1 || e.panels.length > 4 ? (t.push({
		path: "configuration.panels",
		code: "INVALID_PANEL_COUNT",
		message: "Choose between 1 and 4 panels."
	}), t) : (e.panels.forEach((e, n) => {
		let r = `configuration.panels[${n}]`;
		if (!l(e) || !s.has(e.openingType)) {
			t.push({
				path: `${r}.openingType`,
				code: "INVALID_OPENING_TYPE",
				message: "Panel opening type is not supported."
			});
			return;
		}
		(e.openingType === "turn" || e.openingType === "tilt_turn") && (e.hingeSide === void 0 ? t.push({
			path: `${r}.hingeSide`,
			code: "MISSING_HINGE_SIDE",
			message: "Hinge side is required for turn and tilt-and-turn panels."
		}) : c.has(e.hingeSide) || t.push({
			path: `${r}.hingeSide`,
			code: "INVALID_HINGE_SIDE",
			message: "Hinge side must be \"left\" or \"right\"."
		})), e.openingType === "sliding" && (e.slideDirection === void 0 ? t.push({
			path: `${r}.slideDirection`,
			code: "MISSING_SLIDE_DIRECTION",
			message: "Slide direction is required for sliding panels."
		}) : c.has(e.slideDirection) || t.push({
			path: `${r}.slideDirection`,
			code: "INVALID_SLIDE_DIRECTION",
			message: "Slide direction must be \"left\" or \"right\"."
		}));
	}), t);
}
function d(e) {
	if (!l(e)) return {
		valid: !1,
		errors: [{
			path: "model",
			code: "INVALID_MODEL",
			message: "Window model must be an object."
		}]
	};
	let t = [], n = e.measurements;
	return l(n) ? (typeof n.widthMm != "number" || !Number.isFinite(n.widthMm) || n.widthMm <= 0 ? t.push({
		path: "measurements.widthMm",
		code: "INVALID_WIDTH",
		message: "Width must be greater than 0 mm."
	}) : Number.isInteger(n.widthMm) || t.push({
		path: "measurements.widthMm",
		code: "WIDTH_NOT_INTEGER",
		message: "Width must be a whole number of millimetres."
	}), (typeof n.heightMm != "number" || !Number.isFinite(n.heightMm) || n.heightMm <= 0) && t.push({
		path: "measurements.heightMm",
		code: "INVALID_HEIGHT",
		message: "Height must be greater than 0 mm."
	}), n.depthMm !== void 0 && (typeof n.depthMm != "number" || !Number.isFinite(n.depthMm) || n.depthMm <= 0) && t.push({
		path: "measurements.depthMm",
		code: "INVALID_DEPTH",
		message: "Depth must be greater than 0 mm when provided."
	})) : t.push({
		path: "measurements",
		code: "INVALID_MEASUREMENTS",
		message: "Measurements must be an object."
	}), t.push(...u(e.configuration)), l(n) && typeof n.widthMm == "number" && Number.isInteger(n.widthMm) && l(e.configuration) && Array.isArray(e.configuration.panels) && e.configuration.panels.length >= 1 && e.configuration.panels.length <= 4 && n.widthMm < e.configuration.panels.length && t.push({
		path: "measurements.widthMm",
		code: "WIDTH_TOO_SMALL",
		message: `Width must be at least ${e.configuration.panels.length} mm for ${e.configuration.panels.length} panels.`
	}), {
		valid: t.length === 0,
		errors: t
	};
}
//#endregion
//#region src/lib/core/schema.ts
function f(e) {
	let t = u(e);
	if (t.length > 0) throw TypeError(`Invalid window configuration: ${t.map((e) => `${e.path}: ${e.message}`).join(" ")}`);
	let n = e;
	return {
		schemaVersion: 1,
		view: "inside",
		panels: n.panels.map((e) => {
			let t = e.openingType;
			return t === "turn" || t === "tilt_turn" ? {
				openingType: t,
				hingeSide: e.hingeSide
			} : t === "sliding" ? {
				openingType: t,
				slideDirection: e.slideDirection
			} : { openingType: t };
		}),
		...n.frameColor === void 0 ? {} : { frameColor: n.frameColor }
	};
}
//#endregion
//#region src/lib/core/summaries.ts
var p = {
	fixed: "Fixed",
	turn: "Turn",
	tilt: "Tilt",
	tilt_turn: "Tilt & Turn",
	sliding: "Sliding"
};
function m(e) {
	return String(Number.isInteger(e) ? e : Number(e.toFixed(1)));
}
function h(e) {
	return e.panels.map((e) => {
		let t = p[e.openingType];
		return e.openingType === "turn" || e.openingType === "tilt_turn" ? e.hingeSide ? `${t} (${e.hingeSide === "left" ? "LH" : "RH"})` : t : e.openingType === "sliding" && e.slideDirection ? `${t} (${e.slideDirection === "left" ? "Left" : "Right"})` : t;
	}).join(" + ");
}
function g(e, t = {}) {
	let n = [e.widthMm, e.heightMm];
	return t.includeDepth && e.depthMm !== void 0 && n.push(e.depthMm), `${n.map(m).join(" × ")} mm`;
}
var _ = {
	root: "_root_ku4rt_1",
	heading: "_heading_ku4rt_15",
	eyebrow: "_eyebrow_ku4rt_20",
	fieldRow: "_fieldRow_ku4rt_43",
	field: "_field_ku4rt_43",
	fieldLabel: "_fieldLabel_ku4rt_55",
	panel: "_panel_ku4rt_56",
	control: "_control_ku4rt_62",
	error: "_error_ku4rt_85",
	panelControls: "_panelControls_ku4rt_90",
	directionField: "_directionField_ku4rt_111",
	segmentedControl: "_segmentedControl_ku4rt_115",
	active: "_active_ku4rt_139"
}, v = [
	{
		value: "fixed",
		label: "Fixed"
	},
	{
		value: "turn",
		label: "Turn"
	},
	{
		value: "tilt",
		label: "Tilt"
	},
	{
		value: "tilt_turn",
		label: "Tilt & Turn"
	},
	{
		value: "sliding",
		label: "Sliding"
	}
], y = [
	{
		value: "#ffffff",
		label: "White"
	},
	{
		value: "#37474f",
		label: "Anthracite"
	},
	{
		value: "#111111",
		label: "Black"
	}
];
function b(e) {
	return e === "turn" || e === "tilt_turn" ? {
		openingType: e,
		hingeSide: "left"
	} : e === "sliding" ? {
		openingType: e,
		slideDirection: "right"
	} : { openingType: e };
}
function x({ value: e, onChange: n, className: a, disabled: o = !1, allowedOpeningTypes: s }) {
	let c = t().replaceAll(":", ""), l = d(e), u = (e) => l.errors.find((t) => t.path === e)?.message, f = u("measurements.widthMm"), p = u("measurements.heightMm"), m = u("configuration.panels"), h = (t) => (r) => {
		n({
			...e,
			measurements: {
				...e.measurements,
				[t]: r.currentTarget.valueAsNumber
			}
		});
	}, g = (t) => {
		let r = Number(t.currentTarget.value), i = Array.from({ length: r }, (t, n) => e.configuration.panels[n] ?? { openingType: "fixed" });
		n({
			...e,
			configuration: {
				...e.configuration,
				panels: i
			}
		});
	}, x = (t, r) => {
		n({
			...e,
			configuration: {
				...e.configuration,
				panels: e.configuration.panels.map((e, n) => n === t ? r : e)
			}
		});
	}, S = (t, n) => {
		let r = e.configuration.panels[t];
		x(t, r.openingType === "sliding" ? {
			...r,
			slideDirection: n
		} : {
			...r,
			hingeSide: n
		});
	};
	return /* @__PURE__ */ i("form", {
		className: [_.root, a].filter(Boolean).join(" "),
		onSubmit: (e) => e.preventDefault(),
		children: [
			/* @__PURE__ */ i("div", {
				className: _.heading,
				children: [
					/* @__PURE__ */ r("p", {
						className: _.eyebrow,
						children: "Drawing inputs"
					}),
					/* @__PURE__ */ r("h2", { children: "Element details" }),
					/* @__PURE__ */ r("p", { children: "Dimensions are illustrative millimetre values, not manufacturing data." })
				]
			}),
			/* @__PURE__ */ i("div", {
				className: _.fieldRow,
				children: [/* @__PURE__ */ i("div", {
					className: _.field,
					children: [
						/* @__PURE__ */ r("label", {
							htmlFor: `${c}-width`,
							children: "Overall width (mm)"
						}),
						/* @__PURE__ */ r("input", {
							className: _.control,
							id: `${c}-width`,
							type: "number",
							min: "1",
							step: "1",
							disabled: o,
							value: Number.isNaN(e.measurements.widthMm) ? "" : e.measurements.widthMm,
							"aria-invalid": !!f,
							"aria-describedby": f ? `${c}-width-error` : void 0,
							onChange: h("widthMm")
						}),
						f && /* @__PURE__ */ r("span", {
							className: _.error,
							id: `${c}-width-error`,
							children: f
						})
					]
				}), /* @__PURE__ */ i("div", {
					className: _.field,
					children: [
						/* @__PURE__ */ r("label", {
							htmlFor: `${c}-height`,
							children: "Overall height (mm)"
						}),
						/* @__PURE__ */ r("input", {
							className: _.control,
							id: `${c}-height`,
							type: "number",
							min: "1",
							step: "1",
							disabled: o,
							value: Number.isNaN(e.measurements.heightMm) ? "" : e.measurements.heightMm,
							"aria-invalid": !!p,
							"aria-describedby": p ? `${c}-height-error` : void 0,
							onChange: h("heightMm")
						}),
						p && /* @__PURE__ */ r("span", {
							className: _.error,
							id: `${c}-height-error`,
							children: p
						})
					]
				})]
			}),
			/* @__PURE__ */ i("div", {
				className: _.field,
				children: [
					/* @__PURE__ */ r("label", {
						htmlFor: `${c}-panel-count`,
						children: "Number of panels"
					}),
					/* @__PURE__ */ r("select", {
						className: _.control,
						id: `${c}-panel-count`,
						value: e.configuration.panels.length,
						disabled: o,
						"aria-invalid": !!m,
						onChange: g,
						children: [
							1,
							2,
							3,
							4
						].map((e) => /* @__PURE__ */ r("option", {
							value: e,
							children: e
						}, e))
					}),
					m && /* @__PURE__ */ r("span", {
						className: _.error,
						children: m
					})
				]
			}),
			/* @__PURE__ */ r("div", {
				className: _.panelControls,
				children: e.configuration.panels.map((e, t) => {
					let n = e.openingType === "turn" || e.openingType === "tilt_turn" || e.openingType === "sliding", a = e.openingType === "sliding" ? e.slideDirection ?? "right" : e.hingeSide ?? "left", l = e.openingType === "sliding" ? "Sliding direction" : "Hinge side", d = u(`configuration.panels[${t}].hingeSide`) ?? u(`configuration.panels[${t}].slideDirection`);
					return /* @__PURE__ */ i("fieldset", {
						className: _.panel,
						children: [
							/* @__PURE__ */ i("legend", { children: ["Panel ", t + 1] }),
							/* @__PURE__ */ i("div", {
								className: _.field,
								children: [/* @__PURE__ */ r("label", {
									htmlFor: `${c}-panel-${t}-opening`,
									children: "Opening type"
								}), /* @__PURE__ */ i("select", {
									className: _.control,
									id: `${c}-panel-${t}-opening`,
									value: e.openingType,
									disabled: o,
									onChange: (e) => x(t, b(e.currentTarget.value)),
									children: [s && !s.includes(e.openingType) && /* @__PURE__ */ i("option", {
										value: e.openingType,
										disabled: !0,
										children: [v.find((t) => t.value === e.openingType)?.label, " (existing — correct before saving)"]
									}), v.filter((e) => !s || s.includes(e.value)).map((e) => /* @__PURE__ */ r("option", {
										value: e.value,
										children: e.label
									}, e.value))]
								})]
							}),
							n && /* @__PURE__ */ i("div", {
								className: `${_.field} ${_.directionField}`,
								children: [
									/* @__PURE__ */ r("span", {
										className: _.fieldLabel,
										id: `${c}-panel-${t}-direction`,
										children: l
									}),
									/* @__PURE__ */ r("div", {
										className: _.segmentedControl,
										role: "group",
										"aria-labelledby": `${c}-panel-${t}-direction`,
										children: ["left", "right"].map((e) => /* @__PURE__ */ r("button", {
											className: a === e ? _.active : "",
											type: "button",
											disabled: o,
											"aria-pressed": a === e,
											onClick: () => S(t, e),
											children: e === "left" ? "Left" : "Right"
										}, e))
									}),
									d && /* @__PURE__ */ r("span", {
										className: _.error,
										children: d
									})
								]
							})
						]
					}, t);
				})
			}),
			/* @__PURE__ */ i("div", {
				className: _.field,
				children: [/* @__PURE__ */ r("label", {
					htmlFor: `${c}-frame-color`,
					children: "Frame colour (illustrative)"
				}), /* @__PURE__ */ r("select", {
					className: _.control,
					id: `${c}-frame-color`,
					value: e.configuration.frameColor ?? "#ffffff",
					disabled: o,
					onChange: (t) => n({
						...e,
						configuration: {
							...e.configuration,
							frameColor: t.currentTarget.value
						}
					}),
					children: y.map((e) => /* @__PURE__ */ r("option", {
						value: e.value,
						children: e.label
					}, e.value))
				})]
			})
		]
	});
}
//#endregion
//#region src/window-sketch/style.ts
var S = {
	viewBoxWidth: 780,
	viewBoxHeight: 560,
	maximumDrawingWidth: 600,
	maximumDrawingHeight: 330,
	drawingAreaLeft: 58,
	drawingAreaTop: 88,
	outerFrameVisualWidth: 14,
	sashFrameVisualWidth: 9,
	mullionVisualWidth: 10,
	frameStrokeWidth: 2,
	sashStrokeWidth: 1.35,
	symbolStrokeWidth: 1.25,
	dimensionStrokeWidth: 1,
	fontSize: 14,
	labelColor: "#24343b",
	frameStrokeColor: "#17252b",
	symbolColor: "#226678",
	dimensionColor: "#66777d",
	glazingColor: "#eaf5f7",
	defaultFrameColor: "#ffffff"
};
//#endregion
//#region src/window-sketch/components/DimensionLine.tsx
function C({ x1: e, y1: t, x2: n, y2: a, orientation: o, label: s, labelX: c, labelY: l }) {
	let u = o === "horizontal";
	return /* @__PURE__ */ i("g", {
		"data-testid": `overall-${o}-dimension`,
		fill: "none",
		stroke: S.dimensionColor,
		strokeWidth: S.dimensionStrokeWidth,
		vectorEffect: "non-scaling-stroke",
		children: [
			/* @__PURE__ */ r("line", {
				x1: e,
				y1: t,
				x2: n,
				y2: a
			}),
			/* @__PURE__ */ r("line", {
				x1: e + (u ? 0 : -5),
				y1: t + (u ? -5 : 0),
				x2: e + (u ? 0 : 5),
				y2: t + (u ? 5 : 0)
			}),
			/* @__PURE__ */ r("line", {
				x1: n + (u ? 0 : -5),
				y1: a + (u ? -5 : 0),
				x2: n + (u ? 0 : 5),
				y2: a + (u ? 5 : 0)
			}),
			/* @__PURE__ */ r("text", {
				x: c,
				y: l,
				fill: S.labelColor,
				stroke: "none",
				fontSize: S.fontSize,
				fontWeight: 600,
				textAnchor: u ? "middle" : "start",
				dominantBaseline: u ? "auto" : "middle",
				children: s
			})
		]
	});
}
//#endregion
//#region src/window-sketch/components/OuterFrame.tsx
function w({ bounds: e, frameColor: t }) {
	return /* @__PURE__ */ r("rect", {
		"data-testid": "outer-frame",
		x: e.x,
		y: e.y,
		width: e.width,
		height: e.height,
		fill: t,
		stroke: S.frameStrokeColor,
		strokeWidth: S.frameStrokeWidth,
		vectorEffect: "non-scaling-stroke"
	});
}
//#endregion
//#region src/window-sketch/symbols/FixedSymbol.tsx
function T({ x: e, y: t, width: n, height: i }) {
	return /* @__PURE__ */ r("g", {
		"data-symbol": "fixed",
		"data-bounds": `${e},${t},${n},${i}`,
		"aria-label": "Fixed panel",
		children: /* @__PURE__ */ r("title", { children: "Fixed glazing — no opening lines" })
	});
}
//#endregion
//#region src/window-sketch/symbols/SlidingSymbol.tsx
function E({ x: e, y: t, width: n, height: a, direction: o = "right" }) {
	let s = t + a / 2, c = Math.min(n * .2, 18), l = o === "right" ? e + c : e + n - c, u = o === "right" ? e + n - c : e + c, d = Math.min(8, n * .12, a * .1), f = o === "right" ? u - d : u + d;
	return /* @__PURE__ */ i("g", {
		"data-symbol": "sliding",
		"data-direction": o,
		"aria-label": `Sliding ${o}`,
		fill: "none",
		stroke: S.symbolColor,
		strokeWidth: S.symbolStrokeWidth,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: [/* @__PURE__ */ r("line", {
			x1: l,
			y1: s,
			x2: u,
			y2: s
		}), /* @__PURE__ */ r("path", { d: `M ${f} ${s - d} L ${u} ${s} L ${f} ${s + d}` })]
	});
}
//#endregion
//#region src/window-sketch/symbols/TiltSymbol.tsx
function D({ x: e, y: t, width: n, height: i }) {
	let a = e + n / 2;
	return /* @__PURE__ */ r("g", {
		"data-symbol": "tilt",
		"aria-label": "Tilt opening",
		children: /* @__PURE__ */ r("path", {
			d: `M ${e} ${t + i} L ${a} ${t} L ${e + n} ${t + i}`,
			fill: "none",
			stroke: S.symbolColor,
			strokeWidth: S.symbolStrokeWidth,
			vectorEffect: "non-scaling-stroke"
		})
	});
}
//#endregion
//#region src/window-sketch/symbols/TurnSymbol.tsx
function O({ x: e, y: t, width: n, height: i, direction: a = "left" }) {
	let o = a === "left" ? e : e + n, s = a === "left" ? e + n : e, c = t + i / 2;
	return /* @__PURE__ */ r("g", {
		"data-symbol": "turn",
		"data-direction": a,
		"aria-label": `Turn, hinge ${a}`,
		children: /* @__PURE__ */ r("path", {
			d: `M ${o} ${t} L ${s} ${c} L ${o} ${t + i}`,
			fill: "none",
			stroke: S.symbolColor,
			strokeWidth: S.symbolStrokeWidth,
			vectorEffect: "non-scaling-stroke"
		})
	});
}
//#endregion
//#region src/window-sketch/symbols/TiltTurnSymbol.tsx
function k(e) {
	let t = e.direction ?? "left";
	return /* @__PURE__ */ i("g", {
		"data-symbol": "tilt_turn",
		"data-direction": t,
		"aria-label": `Tilt and turn, hinge ${t}`,
		children: [/* @__PURE__ */ r(O, {
			...e,
			direction: t
		}), /* @__PURE__ */ r(D, { ...e })]
	});
}
//#endregion
//#region src/window-sketch/components/PanelFrame.tsx
function A({ geometry: e, frameColor: t }) {
	return /* @__PURE__ */ i("g", {
		"data-testid": "panel-frame",
		"data-panel-index": e.index,
		children: [/* @__PURE__ */ r("rect", {
			x: e.frame.x,
			y: e.frame.y,
			width: e.frame.width,
			height: e.frame.height,
			fill: t,
			stroke: S.frameStrokeColor,
			strokeWidth: S.sashStrokeWidth,
			vectorEffect: "non-scaling-stroke"
		}), /* @__PURE__ */ r("rect", {
			"data-testid": "glazing-area",
			x: e.glazing.x,
			y: e.glazing.y,
			width: e.glazing.width,
			height: e.glazing.height,
			fill: S.glazingColor,
			stroke: S.frameStrokeColor,
			strokeWidth: S.sashStrokeWidth,
			vectorEffect: "non-scaling-stroke"
		})]
	});
}
//#endregion
//#region src/window-sketch/components/Panel.tsx
function j({ configuration: e, geometry: t, frameColor: n }) {
	let a = { ...t.glazing };
	return /* @__PURE__ */ i("g", {
		"data-testid": "panel",
		"data-panel-index": t.index,
		"data-opening-type": e.openingType,
		children: [
			/* @__PURE__ */ r(A, {
				geometry: t,
				frameColor: n
			}),
			e.openingType === "fixed" && /* @__PURE__ */ r(T, { ...a }),
			e.openingType === "turn" && /* @__PURE__ */ r(O, {
				...a,
				direction: e.hingeSide ?? "left"
			}),
			e.openingType === "tilt" && /* @__PURE__ */ r(D, { ...a }),
			e.openingType === "tilt_turn" && /* @__PURE__ */ r(k, {
				...a,
				direction: e.hingeSide ?? "left"
			}),
			e.openingType === "sliding" && /* @__PURE__ */ r(E, {
				...a,
				direction: e.slideDirection ?? "right"
			})
		]
	});
}
//#endregion
//#region src/window-sketch/dimensions.ts
function M(e) {
	let { frame: t } = e, n = t.y + t.height + 68, r = t.x + t.width + 42;
	return {
		panelLabelY: t.y + t.height + 30,
		overallWidth: {
			x1: t.x,
			y1: n,
			x2: t.x + t.width,
			y2: n,
			labelX: t.x + t.width / 2,
			labelY: n + 22
		},
		overallHeight: {
			x1: r,
			y1: t.y,
			x2: r,
			y2: t.y + t.height,
			labelX: r + 12,
			labelY: t.y + t.height / 2
		}
	};
}
function N(e) {
	return Number.isInteger(e) ? e.toString() : e.toLocaleString("en", { maximumFractionDigits: 1 });
}
//#endregion
//#region src/window-sketch/geometry.ts
function P(e, t, n = S.maximumDrawingWidth, r = S.maximumDrawingHeight) {
	if (e <= 0 || t <= 0) throw RangeError("Window width and height must be greater than zero.");
	return Math.min(n / e, r / t);
}
function F(e, t) {
	let n = P(e, t), r = e * n, i = t * n;
	return {
		x: S.drawingAreaLeft + (S.maximumDrawingWidth - r) / 2,
		y: S.drawingAreaTop + (S.maximumDrawingHeight - i) / 2,
		width: r,
		height: i
	};
}
function I(e, t) {
	if (!Number.isInteger(t) || t < 1 || t > 4) throw RangeError("Panel count must be an integer from 1 to 4.");
	if (!Number.isInteger(e) || e <= 0) throw RangeError("Overall width must be a positive whole number.");
	if (e < t) throw RangeError("Overall width must allow at least 1 mm per panel.");
	let n = Math.floor(e / t), r = e % t;
	return Array.from({ length: t }, (e, t) => n + +(t < r));
}
function L(e, t, n) {
	let r = I(n, t), i = Math.min(S.outerFrameVisualWidth, e.width * .12, e.height * .12), a = t > 1 ? S.mullionVisualWidth / 2 : 0, o = 0;
	return r.map((r, s) => {
		let c = o;
		o += r;
		let l = e.x + c / n * e.width, u = s === t - 1 ? e.x + e.width : e.x + o / n * e.width, d = {
			x: l,
			y: e.y,
			width: u - l,
			height: e.height
		}, f = s === 0 ? i : a, p = s === t - 1 ? i : a, m = {
			x: d.x + f,
			y: e.y + i,
			width: Math.max(0, d.width - f - p),
			height: Math.max(0, e.height - i * 2)
		}, h = Math.min(S.sashFrameVisualWidth, m.width * .16, m.height * .16);
		return {
			index: s,
			section: d,
			frame: m,
			glazing: {
				x: m.x + h,
				y: m.y + h,
				width: Math.max(0, m.width - h * 2),
				height: Math.max(0, m.height - h * 2)
			},
			widthMillimetres: r
		};
	});
}
function R(e) {
	let t = z(e);
	if (Object.keys(t).length > 0) throw RangeError(Object.values(t).join(" "));
	let n = F(e.width, e.height);
	return {
		frame: n,
		panels: L(n, e.panels.length, e.width),
		scale: P(e.width, e.height)
	};
}
function z(e) {
	let t = {};
	return !Number.isFinite(e.width) || e.width <= 0 ? t.width = "Width must be greater than 0 mm." : Number.isInteger(e.width) ? e.panels.length >= 1 && e.panels.length <= 4 && e.width < e.panels.length && (t.width = `Width must be at least ${e.panels.length} mm for ${e.panels.length} panels.`) : t.width = "Width must be a whole number of millimetres.", (!Number.isFinite(e.height) || e.height <= 0) && (t.height = "Height must be greater than 0 mm."), (e.panels.length < 1 || e.panels.length > 4) && (t.panels = "Choose between 1 and 4 panels."), t;
}
//#endregion
//#region src/window-sketch/WindowSketch.tsx
var B = {
	fixed: "fixed",
	turn: "turn",
	tilt: "tilt",
	tilt_turn: "tilt and turn",
	sliding: "sliding"
};
function V({ item: e, className: a, style: o, showItemLabel: s = !0, showDimensions: c = !0, showPanelDimensions: l, showViewLabel: u = !0, accessibleLabel: d, frameVariant: f = "window" }) {
	let p = t().replaceAll(":", ""), m = `window-sketch-title-${p}`, h = `window-sketch-description-${p}`, g = R(e), _ = M(g), v = e.frameColor ?? S.defaultFrameColor, y = l ?? c, b = e.panels.map((e, t) => {
		let n = e.openingType === "sliding" ? e.slideDirection : e.openingType === "turn" || e.openingType === "tilt_turn" ? `hinge ${e.hingeSide ?? "left"}` : void 0;
		return `panel ${t + 1}: ${B[e.openingType]}${n ? `, ${n}` : ""}`;
	}).join("; ");
	return /* @__PURE__ */ i("svg", {
		className: a,
		style: o,
		"data-testid": f === "door" ? "door-sketch" : "window-sketch",
		viewBox: `0 0 ${S.viewBoxWidth} ${S.viewBoxHeight}`,
		preserveAspectRatio: "xMidYMid meet",
		role: "img",
		"aria-labelledby": `${m} ${h}`,
		xmlns: "http://www.w3.org/2000/svg",
		children: [
			/* @__PURE__ */ r("title", {
				id: m,
				children: d ?? `${e.itemId ? `${e.itemId} ` : ""}window sketch, view from inside`
			}),
			/* @__PURE__ */ r("desc", {
				id: h,
				children: `${N(e.width)} by ${N(e.height)} millimetres; ${b}.`
			}),
			s && /* @__PURE__ */ r("text", {
				x: S.viewBoxWidth / 2,
				y: 29,
				textAnchor: "middle",
				fill: S.labelColor,
				fontSize: 19,
				fontWeight: 700,
				children: e.itemId || "UNTITLED ITEM"
			}),
			u && /* @__PURE__ */ r("text", {
				x: S.viewBoxWidth / 2,
				y: 52,
				textAnchor: "middle",
				fill: S.labelColor,
				fontSize: 12,
				fontWeight: 700,
				letterSpacing: 1.4,
				children: "VIEW FROM INSIDE"
			}),
			/* @__PURE__ */ r(w, {
				bounds: g.frame,
				frameColor: v
			}),
			g.panels.map((t, n) => /* @__PURE__ */ r(j, {
				configuration: e.panels[n],
				geometry: t,
				frameColor: v
			}, t.index)),
			g.panels.slice(0, -1).map((e) => {
				let t = e.section.x + e.section.width;
				return /* @__PURE__ */ r("rect", {
					"data-testid": "mullion",
					x: t - S.mullionVisualWidth / 2,
					y: g.frame.y,
					width: S.mullionVisualWidth,
					height: g.frame.height,
					fill: v,
					stroke: S.frameStrokeColor,
					strokeWidth: S.sashStrokeWidth,
					vectorEffect: "non-scaling-stroke"
				}, `mullion-${e.index}`);
			}),
			f === "door" && /* @__PURE__ */ r("rect", {
				"data-testid": "door-threshold",
				x: g.frame.x,
				y: g.frame.y + g.frame.height - 6,
				width: g.frame.width,
				height: 6,
				fill: v,
				stroke: S.frameStrokeColor,
				strokeWidth: S.sashStrokeWidth,
				vectorEffect: "non-scaling-stroke"
			}),
			y && g.panels.map((e) => /* @__PURE__ */ r("text", {
				"data-testid": "panel-width-label",
				x: e.section.x + e.section.width / 2,
				y: _.panelLabelY,
				textAnchor: "middle",
				fill: S.dimensionColor,
				fontSize: S.fontSize,
				children: N(e.widthMillimetres)
			}, `panel-dimension-${e.index}`)),
			c && /* @__PURE__ */ i(n, { children: [
				/* @__PURE__ */ r("line", {
					x1: g.frame.x,
					y1: g.frame.y + g.frame.height + 8,
					x2: g.frame.x,
					y2: _.overallWidth.y1 + 5,
					stroke: S.dimensionColor,
					strokeWidth: S.dimensionStrokeWidth
				}),
				/* @__PURE__ */ r("line", {
					x1: g.frame.x + g.frame.width,
					y1: g.frame.y + g.frame.height + 8,
					x2: g.frame.x + g.frame.width,
					y2: _.overallWidth.y1 + 5,
					stroke: S.dimensionColor,
					strokeWidth: S.dimensionStrokeWidth
				}),
				/* @__PURE__ */ r(C, {
					..._.overallWidth,
					orientation: "horizontal",
					label: `L = ${N(e.width)} mm`
				}),
				/* @__PURE__ */ r("line", {
					x1: g.frame.x + g.frame.width + 8,
					y1: g.frame.y,
					x2: _.overallHeight.x1 + 5,
					y2: g.frame.y,
					stroke: S.dimensionColor,
					strokeWidth: S.dimensionStrokeWidth
				}),
				/* @__PURE__ */ r("line", {
					x1: g.frame.x + g.frame.width + 8,
					y1: g.frame.y + g.frame.height,
					x2: _.overallHeight.x1 + 5,
					y2: g.frame.y + g.frame.height,
					stroke: S.dimensionColor,
					strokeWidth: S.dimensionStrokeWidth
				}),
				/* @__PURE__ */ r(C, {
					..._.overallHeight,
					orientation: "vertical",
					label: `A = ${N(e.height)} mm`
				})
			] })
		]
	});
}
//#endregion
//#region src/lib/internal/legacyAdapter.ts
function H(e, t = "") {
	return {
		itemId: t,
		width: e.measurements.widthMm,
		height: e.measurements.heightMm,
		view: e.configuration.view,
		panels: e.configuration.panels.map((e) => ({ ...e })),
		frameColor: e.configuration.frameColor
	};
}
//#endregion
//#region src/lib/renderer/WindowSketch.tsx
function U({ model: e, label: n, accessibleLabel: a, ...o }) {
	let s = t().replaceAll(":", ""), c = d(e), l = a ?? [
		n,
		c.valid ? h(e.configuration) : void 0,
		c.valid ? g(e.measurements) : void 0
	].filter(Boolean).join(" — ");
	if (!c.valid) {
		let e = `invalid-window-sketch-title-${s}`, t = `invalid-window-sketch-description-${s}`;
		return /* @__PURE__ */ i("svg", {
			className: o.className,
			style: o.style,
			viewBox: "0 0 780 560",
			preserveAspectRatio: "xMidYMid meet",
			role: "img",
			"aria-labelledby": `${e} ${t}`,
			xmlns: "http://www.w3.org/2000/svg",
			children: [
				/* @__PURE__ */ r("title", {
					id: e,
					children: l || "Invalid window sketch"
				}),
				/* @__PURE__ */ r("desc", {
					id: t,
					children: c.errors.map((e) => e.message).join(" ")
				}),
				/* @__PURE__ */ r("rect", {
					x: "1",
					y: "1",
					width: "778",
					height: "558",
					fill: "#ffffff",
					stroke: "#b8c2c4"
				}),
				/* @__PURE__ */ r("text", {
					x: "390",
					y: "270",
					textAnchor: "middle",
					fill: "#8d3030",
					fontSize: "18",
					children: "Unable to render window sketch"
				}),
				/* @__PURE__ */ r("text", {
					x: "390",
					y: "298",
					textAnchor: "middle",
					fill: "#66777d",
					fontSize: "13",
					children: "Check the configuration and measurements."
				})
			]
		});
	}
	return /* @__PURE__ */ r(V, {
		item: H(e, n),
		accessibleLabel: l || void 0,
		...o
	});
}
//#endregion
//#region src/lib/renderer/renderWindowSketchSvg.ts
function W(t, n = {}) {
	return a(e(U, {
		model: t,
		...n
	}));
}
//#endregion
//#region src/lib/renderer/DoorSketch.tsx
function G(e) {
	return /* @__PURE__ */ r(U, {
		...e,
		frameVariant: "door",
		accessibleLabel: e.accessibleLabel ?? `${e.label ?? "Door"} — door sketch`
	});
}
function K(t, n = {}) {
	return a(e(G, {
		model: t,
		...n
	}));
}
//#endregion
export { G as DoorSketch, x as OpeningEditor, U as WindowSketch, o as createDefaultWindowModel, g as getDimensionSummary, h as getOperationSummary, f as parseWindowConfiguration, K as renderDoorSketchSvg, W as renderWindowSketchSvg, d as validateWindowModel };
